import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DLRootCertificate } from './root-certificate';
import { DLRootCertificateService } from './root-certificate.service';
import { NotifierService, DialogService } from '../../ui';
import { FormControl, Validators } from '@angular/forms';

type ViewMode = 'view' | 'new' | 'edit';

@Component({
  templateUrl: './root-certificate-edit.component.html',
})
export class DLRootCertificateEditComponent implements OnInit, AfterViewInit {

  rootCertificate: DLRootCertificate

  mode: ViewMode
  title: string

  @ViewChild('pemInput')
  pemInput: ElementRef

  pem: FormControl

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rootCertificateService: DLRootCertificateService,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  initForm() {
    // pem
    this.pem = new FormControl(this.rootCertificate.pem, [
      Validators.required
    ]);

    this.pem.valueChanges.subscribe((value) => {
      this.rootCertificate.pem = value;
    });
  }
  
  ngAfterViewInit() {
    // Focus pem input
    if (this.pemInput) {
      this.pemInput.nativeElement.focus();
    }
  }

  ngOnInit() {

    this.mode = this.route.routeConfig.data.mode;
    this.title = this.route.routeConfig.data.title;

    switch (this.mode) {
      case 'new': 
        {
          this.rootCertificate = new DLRootCertificate();

          this.initForm();
        }
        break;

      case 'edit':
        {
          // Get the rootCertificate
          this.notifier.startProgress();

          this.route.data.subscribe((data) => {
            this.rootCertificate = data.rootCertificate;

            this.initForm();

            this.notifier.endProgress();
          });
        }
        break;

      case 'view':
        {
          // Get the rootCertificate
          this.notifier.startProgress();

          this.route.data.subscribe((data) => {
            this.rootCertificate = data.rootCertificate;

            this.notifier.endProgress();
          });
        }
        break;
    }
  }

  save() {
    if (!this.rootCertificate || !this.rootCertificate.valid) {
      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    switch (this.mode) {
      case 'new':
        {
          this.rootCertificateService
            .create(this.rootCertificate).pipe(
            finalize(onComplete))
            .subscribe((rootCertificate) => {
              this.rootCertificate = rootCertificate;

              this.notifier.success('Certificat racine créé avec succès');

              // Got to view screen
              this.router.navigate(['documents-ledger', 'root-certificates', rootCertificate.id]);
            });
        }
        break;

      case 'edit':
        {
          this.rootCertificateService
            .update(this.rootCertificate.id, this.rootCertificate).pipe(
            finalize(onComplete))
            .subscribe((rootCertificate) => {
              this.rootCertificate = rootCertificate;

              this.notifier.success('Certificat racine enregistré avec succès');

              // Got to view screen
              this.router.navigate(['documents-ledger', 'root-certificates', rootCertificate.id]);
            });
        }
        break;
    }
  }

  cancel() {
    if (this.mode === 'edit') {
      this.router.navigate(['documents-ledger', 'root-certificates', this.rootCertificate.id]);
    }
    else {
      this.router.navigate(['documents-ledger', 'root-certificates']);
    }
  }

  delete() {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer ce certificat racine?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.rootCertificateService
          .delete(this.rootCertificate.id)
          .subscribe((id) => {
            this.notifier.success('Certificat racine supprimé avec succès');

            this.router.navigate(['documents-ledger', 'root-certificates']);

          }, (err) => {
            this.notifier.endProgress();
          });
      });
    
    return false;
  }
}
